import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentUser: {},
    token: '',
    auth: '',
    loginTab : 0,
    signUpTab : 0
}

const name = 'auth'
const parentSelector = state => state?.[name]

const authSlice = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        resetAuth: (state, action) => {
            return {
                ...state,
                loginTab: 0,
                signUpTab: 0
            };
        },
        loginUserStatus: (state, action) => {
            console.log("Setting Status")
            return {
                ...state,
                auth: action.payload,
            };
        },
        setCurrentUserSlice: (state, action) => {
            return {
                ...state,
                currentUser: action.payload,
            };
        },
        setLoginTab: (state, action) => {
            return {
                ...state,
                loginTab: action.payload,
            };
        },
        setSignUpTab: (state, action) => {
            return {
                ...state,
                signUpTab: action.payload,
            };
        }
    },
});


const getCurrentUser = createSelector(parentSelector, state => {
    return state?.currentUser  
})
const getLoggedInStatus = createSelector(parentSelector, state => {
    return state?.auth
})
const getLoginTab = createSelector(parentSelector, state => {
    return state?.loginTab
})
const getSignUpTab = createSelector(parentSelector, state => {
    return state?.signUpTab
})

const actions = {
    ...authSlice.actions
}

const selectors = {
    getLoggedInStatus ,
    getCurrentUser ,
    getLoginTab,
    getSignUpTab
}

export const authActions = { actions, selectors }


export default authSlice;